import React, { createContext, useContext, useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import { use } from 'react';
import { useLocation } from 'react-router-dom';
import { getAllCardDetailsReducer, getAllCardInfoReducer } from '../Redux/Reducers/CardReducer';
import { useDispatch } from 'react-redux';

const UserDetailContext = createContext();

export const UserDetailProvider = ({ children }) => {
    const apiKey = process.env.REACT_APP_API_KEY;
    const objectId = localStorage.getItem("objectId");
    const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${objectId}`,
        // "ngrok-skip-browser-warning": "69420"
    };

    const [userDetails, setUserDetails] = useState({
        objectIdnew: "",
        name: "FirstName LastName",
        profession: "Profession",
        phone: "",
        companyname: "DaLocal",
        email: "",
        website: "www.example.com",
        location: "Bengaluru, Karnataka",
        type: "Business Card",
        dob: '',
        reference_id: ''
    });


    const [cards, setCards] = useState([]);
    const [favoriteCards, setFavoriteCards] = useState([]);
    const [AllCards, setOtherCards] = useState([]);
    const [cardDetailsAll, setCardDetailsAll] = useState([]);
    const [cardStylesAll, setCardStylesAll] = useState([]);
    const [cardQrStylesAll, setCardQrStylesAll] = useState([]);
    const [cardContactsAll, setCardContactsAll] = useState([]);
    const [cardSocialLinkWebsites, setCardSocialLinkWebsites] = useState([]);
    const dispatch = useDispatch();
    // Ref to ensure profile is fetched only once
    const isProfileFetched = useRef(false);

    // Fetch user profile and cards
    const [localStoreUserDetails, setLocalStoreUserDetails] = useState(null);
    const [groupCardDetails, setGroupCardDetails] = useState([]); // Group cards
    const apifetching = useRef(false);

    // useEffect(() => {
    //     if (isProfileFetched.current || !objectId) return; // Prevent multiple fetches
    //     isProfileFetched.current = true;

    //     const fetchUserProfile = async () => {
    //         if (apifetching.current) return;
    //         apifetching.current = true;
    //         try {
    //             const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/mail/user`, { headers });
    //             if (!objectId) {
    //                 // alert("Object ID is not available");
    //                 return;
    //             }
    //             localStorage.setItem("userDetails", JSON.stringify(response.data));
    //             setLocalStoreUserDetails(response.data);



    //             if (response.status === 200) {
    //                 const data = response.data;

    //                 const { id, first_name, last_name, phone_no, email, profile_url, unique_id, qrCodeImage, dob, reference_id } = data;
    //                 setUserDetails(prevData => ({
    //                     ...prevData,
    //                     objectIdnew: id,
    //                     name: `${first_name} ${last_name}`,
    //                     firstName: first_name,
    //                     lastName: last_name,
    //                     phone: phone_no,
    //                     email: email,
    //                     proFile: profile_url,
    //                     uniqueId: unique_id,
    //                     neoinwithqr: `data:image/png;base64,${qrCodeImage}`,
    //                     dob: dob,
    //                     reference_id: reference_id
    //                 }));
    //             }

    //             const cardResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/card-details`, { headers });
    //             if (cardResponse.status === 200) {
    //                 const data = cardResponse.data;

    //                 const uniqueCardNames = new Set();
    //                 const uniqueOtherCards = new Map();
    //                 const groupCards = [];

    //                 data.forEach((item) => {
    //                     if (item.group_id) {
    //                         groupCards.push({
    //                             ...item,
    //                             group_name: item.card_name,
    //                         });
    //                     } else if (item.card_name?.trim()) {
    //                         uniqueCardNames.add(item.card_name);
    //                         const key = `${item.card_name}-${item.card_type}`;
    //                         if (!uniqueOtherCards.has(key)) {
    //                             uniqueOtherCards.set(key, { ...item });
    //                         }
    //                     }
    //                 });

    //                 setCards([...uniqueCardNames]);
    //                 setOtherCards([...uniqueOtherCards.values()]);
    //                 setGroupCardDetails(groupCards);

    //                 const favoriteCardNames = data.filter((card) => card.is_favourite === 1).map((card) => card.card_name);
    //                 setFavoriteCards(favoriteCardNames);
    //             }
    //         } catch (error) {
    //             console.error("Error fetching user details or card data:", error);
    //         }
    //     };

    //     fetchUserProfile();
    // }, [objectId]);



    const getCardDetails = useCallback(async () => {
        if (isProfileFetched.current || !objectId) return; // Prevent multiple fetches
        isProfileFetched.current = true;

        const fetchUserProfile = async () => {
            if (apifetching.current) return;
            apifetching.current = true;

            // Check if localStorage already has userDetails
            const localUserDetails = localStorage.getItem("userDetails");

            if (localUserDetails) {
                // Parse and use the stored data
                const parsedData = JSON.parse(localUserDetails);
                setLocalStoreUserDetails(parsedData);

                const { id, first_name, last_name, phone_no, email, profile_url, unique_id, qrCodeImage, dob, reference_id } = parsedData;

                setUserDetails(prevData => ({
                    ...prevData,
                    objectIdnew: id,
                    name: `${first_name} ${last_name}`,
                    firstName: first_name,
                    lastName: last_name,
                    phone: phone_no,
                    email: email,
                    proFile: profile_url,
                    uniqueId: unique_id,
                    neoinwithqr: `data:image/png;base64,${qrCodeImage}`,
                    dob: dob,
                    reference_id: reference_id
                }));
            } else {
                // Fetch data from API if not in localStorage
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/user`, { headers });
                    if (!objectId) {
                        console.error("Object ID is not available");
                        return;
                    }

                    if (response?.data?.statusCode === 200) {
                        localStorage.setItem("userDetails", JSON.stringify(response.data?.data?.user));
                        setLocalStoreUserDetails(response.data?.data?.user);

                        const { id, first_name, last_name, phone_no, email, profile_url, unique_id, qrCodeImage, dob, reference_id } = response.data?.data?.user;

                        setUserDetails(prevData => ({
                            ...prevData,
                            objectIdnew: id,
                            name: `${first_name} ${last_name}`,
                            firstName: first_name,
                            lastName: last_name,
                            phone: phone_no,
                            email: email,
                            proFile: profile_url,
                            uniqueId: unique_id,
                            neoinwithqr: `data:image/png;base64,${qrCodeImage}`,
                            dob: dob,
                            reference_id: reference_id
                        }));
                    }
                } catch (error) {
                    console.error("Error fetching user details:", error);
                }
            }

            // Fetch card details
            try {
                const cardResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/card-details`, { headers });

                // const cardResponse = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/get-all-cards-info`, { headers });
                // console.log("CARDA DATAAA", cardResponse);
                if (cardResponse.status === 200) {
                    const data = cardResponse.data;

                    await dispatch(getAllCardDetailsReducer());
                    await dispatch(getAllCardInfoReducer());
                    const uniqueCardNames = new Set();
                    const uniqueOtherCards = new Map();
                    const groupCards = [];

                    data?.forEach((item) => {
                        if (item.group_id) {
                            groupCards.push({
                                ...item,
                                group_name: item.card_name,
                            });
                        } else if (item.card_name?.trim()) {
                            uniqueCardNames.add(item.card_name);
                            const key = `${item.card_name}-${item.card_type}`;
                            if (!uniqueOtherCards.has(key)) {
                                uniqueOtherCards.set(key, { ...item });
                            }
                        }
                    });

                    setCards([...uniqueCardNames]);
                    setOtherCards([...uniqueOtherCards.values()]);
                    setGroupCardDetails(groupCards);

                    const favoriteCardNames = data.filter((card) => card.is_favourite === 1).map((card) => card.card_name);
                    setFavoriteCards(favoriteCardNames);
                }
            } catch (error) {
                console.error("Error fetching card data:", error);
            }
        };

        fetchUserProfile();
    }, [objectId]);

    useEffect(() => {
        getCardDetails();

    }, []);



    const fetchedCardDetails = useRef(new Set());

    const fetchCardDetailsAndStyles = useCallback(async () => {


        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/get-all-cards-info`, {
                headers,
            });


            const { Details = [], CardDesigns = [], QrStyles = [], CardContacts = [], CardSocialLinksWebsites = [] } = response.data;

            // Update state without overwriting
            setCardDetailsAll((prev) => [...prev, ...Details]);
            // console.log("GET ALL CARDSS DATA", cardDetailsAll);
            setCardStylesAll((prev) => [...prev, ...CardDesigns]);
            setCardQrStylesAll((prev) => [...prev, ...QrStyles]);
            setCardContactsAll((prev) => [...prev, ...CardContacts]);
            setCardSocialLinkWebsites((prev) => [...prev, ...CardSocialLinksWebsites]);
        } catch (error) {
            console.error(`Error fetching card details for :`, error);
        }
    }, [AllCards])


    useEffect(() => {
        fetchCardDetailsAndStyles();
    }, []);



    return (

        // <UserDetailContext.Provider value={{ cardDetailsAll, groupCardDetails, cardStylesAll, AllCards, setOtherCards, userDetails, cards, favoriteCards, setFavoriteCards, setUserDetails, setCards, localStoreUserDetails }}>
        //     {children}
        // </UserDetailContext.Provider>
        <UserDetailContext.Provider value={{ cardDetailsAll, groupCardDetails, cardStylesAll, AllCards, setOtherCards, userDetails, cards, favoriteCards, setFavoriteCards, setUserDetails, setCards, cardQrStylesAll, setCardQrStylesAll, cardSocialLinkWebsites, cardContactsAll }}>
            {children}
        </UserDetailContext.Provider>
    );
};

export const useUserDetailContext = () => useContext(UserDetailContext);

export default UserDetailContext;
